import { createState } from 'shared'
import type { OnboardingAnswersPayload, OnboardingQuestions } from 'core'

import { application, freePlanId, updateOnboardedState } from 'state'

const isOnboardLoading = createState(false)
const onboardingAnswers = createState<{ [name: string]: string }>({})
const onboardingQuestions = createState<OnboardingQuestions[]>([])

export const getOnboardingQuestions = async () => {
	isOnboardLoading.updateState(() => true)

	const { data: questions, error } = await application.value
		.forOnboardingUser()
		.getOnboardingQuestions()

	isOnboardLoading.updateState(() => false)

	if (error) {
		// TODO: Handle error
		return onboardingQuestions.updateState(() => [])
	}

	return onboardingQuestions.updateState(() => questions || [])
}

export const selectOnboardingAnswers = (
	answerId: string,
	answerValue: string
) => {
	if (!answerId || !answerValue) {
		throw new Error('No answer selected')
	}

	onboardingAnswers.updateState(prevState => ({
		...prevState,
		[answerId]: answerValue
	}))
}

export const completeOnboardProcess = async () => {
	if (!freePlanId.peek()) {
		throw new Error('Free plan not found')
	}
	if (!Object.keys(onboardingAnswers.state.peek()).length) {
		throw new Error('No answers selected')
	}
	if (
		Object.keys(onboardingAnswers.state.peek()).length !==
		onboardingQuestions.state.peek().length
	) {
		throw new Error('Not all questions were answered')
	}

	isOnboardLoading.updateState(() => true)

	const payload: OnboardingAnswersPayload = {
		onboardingAnswers: Object.entries(onboardingAnswers.state.peek()).map(
			([key, value]) => ({
				questionId: Number(key),
				questionOptionId: Number(value)
			})
		),
		planId: freePlanId.peek()
	}

	const { data, error } = await application.value
		.forOnboardingUser()
		.completeOnboardProcess(payload)

	isOnboardLoading.updateState(() => false)

	if (error) {
		// TODO: Handle error
		throw new Error(error.message)
	}

	if (data) {
		updateOnboardedState(true)
		return true
	}

	updateOnboardedState(false)
	return false
}

export const closeOnboardProcess = async () => {
	if (!freePlanId.peek()) {
		// TODO: handle error
		throw new Error('Free plan not found')
	}

	isOnboardLoading.updateState(() => true)

	const { data, error } = await application.value
		.forOnboardingUser()
		.completeOnboardProcess({
			onboardingAnswers: [],
			planId: freePlanId.peek()
		})

	isOnboardLoading.updateState(() => false)

	if (error) {
		// TODO: Handle error
		return onboardingQuestions.updateState(() => [])
	}

	if (data) {
		updateOnboardedState(true)
		return true
	}

	updateOnboardedState(false)
	return false
}

export const resetOnboardingAnswers = () => {
	onboardingAnswers.updateState(() => ({}))
}

export const resetOnboardingQuestions = () => {
	onboardingQuestions.updateState(() => [])
}

export const resetOnboardingState = () => {
	resetOnboardingAnswers()
	resetOnboardingQuestions()
}

export const isOnboardLoadingState = isOnboardLoading.state
export const onboardingAnswersState = onboardingAnswers.state
export const onboardingQuestionsState = onboardingQuestions.state
